import { Form } from 'factorial-form'

import { ALL_TYPES } from 'modules/documents/store/models/Document'
import type Leave from 'modules/timeoff/store/models/Leave'
import { FIXED_LEAVE_IDENTIFIERS } from 'modules/timeoff/store/models/LeaveType'

export interface CustomFieldAttributes {
  value: string | number | boolean | null
  // NOTE: this references the resource_field_id in the backend
  resource_id: string
}

class LeaveDocumentForm extends Form {
  constructor(values: {}) {
    super(values, {
      file: 'file',
      type: 'string',
      leave_id: 'number',
      employee_id: 'number',
      public: 'boolean',
      folder_id: 'number',
      custom_fields: 'any',
    })
  }

  documentType(leave: Leave): string | null | undefined {
    const identifier = leave.leaveType?.attributes.identifier

    return identifier === FIXED_LEAVE_IDENTIFIERS.sick ? ALL_TYPES.sick_leave : null
  }

  setDocumentValues(
    leave: Leave,
    customFieldsAttributes: CustomFieldAttributes[],
    employeeId: number,
    sickFolderId: number
  ) {
    this.setValues({
      type: this.documentType(leave),
      leave_id: leave.attributes.id,
      employee_id: employeeId,
      public: true,
      folder_id: sickFolderId,
      custom_fields: customFieldsAttributes,
    })
  }
}

export default LeaveDocumentForm
